export default {
    disclaimer: {
        label_default: "Reconozco y acepto que los artículos que estoy pidiendo/recibiendo son propiedad de O-I para ser utilizados en actividades relacionadas con el trabajo de O-I y, como tal, O-I se reserva el derecho de solicitar la devolución de la propiedad cuando salga de O-I (o antes, si O-I lo requiere).",
        label_type_1: "Confirmo que la autoevaluación para el trabajo desde casa se completó de forma precisa y de buena fe, y que cualquier equipo o mueble proporcionado desde la ubicación de O-I o pedido a través de Gear será utilizado por mí para el propósito de mi trabajo con O-I. Reconozco y acepto que los artículos que estoy pidiendo/recibiendo son propiedad de O-I para ser utilizados para actividades relacionadas con el trabajo de O-I, y como tal, O-I se reserva el derecho de solicitar la devolución de la propiedad cuando me retire de O-I (o antes, si O-I lo requiere).",
        errors: {
            required: "Por favor, acepte los términos de uso"
        }
    },
    cost_center: {
        label: "Código del centro de costos",
        placeholder: "Código del centro de costos",
        cost_center_not_found: "Los centros de costos que no aparecen pueden tardar hasta 24 horas en mostrarse. Si no ve el centro de costos correspondiente, póngase en contacto con el Servicio de Asistencia Global.",
        errors: {
            regex: "Código de centro de costos no válido"
        }
    },
    company_code: {
        label: "Código de la empresa"
    },
    cost_center_name: {
        label: "Nombre del centro de costos"
    },
    order_note: {
        label: "Nota de pedido",
        placeholder: "Nota opcional para el gerente para su aprobación",
    },
    send_emails_to_oobo_orderer: {
        "OOBO": "Notificarme cuando haya novedades sobre este pedido"
    },
    "dell_banner":{
        label: "Debido a las actualizaciones del sistema Dell, los pedidos realizados entre el 1 y el 14 de agosto de 2026 podrían sufrir retrasos importantes en su procesamiento. Le rogamos que tenga en cuenta que los plazos de entrega pueden ser más largos durante este periodo. Gracias por su comprensión."
    }
}